import React from 'react';
import { createSvgIcon } from '@material-ui/core';

export const MessagingWaitQueueIcon = createSvgIcon(
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" strokeWidth="0" />
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
        <g id="SVGRepo_iconCarrier">
            <path d="M11.2721 36.7279C14.5294 39.9853 19.0294 42 24 42C33.9411 42 42 33.9411 42 24C42 14.0589 33.9411 6 24 6C19.0294 6 14.5294 8.01472 11.2721 11.2721C9.6141 12.9301 6 17 6 17" stroke="#000000" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" /> 
            <path d="M6 9V17H14" stroke="#000000" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" /> 
            <path d="M28 18H21V23.7098C21.9845 23.0633 22.4689 23 24 23C27 23 28 24.9886 28 28C28 31.0114 26 32 24 32C22.5 32 21 31 21 30" stroke="#000000" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>
    ,
    'Messaging - Wait Queue',
);

